import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { fetchProductsStart } from './../../redux/Products/products.actions';
import Product from './Product';
import FormSelect from './../forms/FormSelect';
import LoadMore from './../LoadMore';
import { motion } from 'framer-motion';
import './styles.scss';

const mapState = ({ productsData }) => ({
  products: productsData.products
});

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.15
    }
  }
};

const productVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

const ProductResults = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { filterType } = useParams();
  const { products } = useSelector(mapState);

  const { data, queryDoc, isLastPage } = products;

  useEffect(() => {
    dispatch(fetchProductsStart({ filterType }));
  }, [filterType]);

  const handleFilter = (e) => {
    const nextFilter = e.target.value;
    history.push(`/search/${nextFilter}`);
  };

  const handleLoadMore = () => {
    dispatch(fetchProductsStart({
      filterType,
      startAfterDoc: queryDoc,
      persistProducts: data
    }));
  };

  if (!Array.isArray(data)) return null;

  return (
    <motion.div
      className="products"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {!props?.hide && (
        <motion.div
          className="products-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Browse Products</h1>
          <FormSelect
            defaultValue={filterType}
            options={[
              { name: 'Show all', value: '' },
              { name: 'Womens', value: 'womens' },
              { name: 'Kids', value: 'kids' },
              { name: 'Mens', value: 'mens' },
            ]}
            handleChange={handleFilter}
          />
        </motion.div>
      )}

      {data.length < 1 ? (
        <motion.div
          className="no-results"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <p>No search results.</p>
        </motion.div>
      ) : (
        <motion.div
          className="productResults"
          variants={containerVariants}
        >
          {data.map((product, pos) => {
            const { productThumbnail, productName, productPrice } = product;
            if (!productThumbnail || !productName || typeof productPrice === 'undefined') return null;

            return (
              <motion.div
                key={pos}
                variants={productVariants}
                whileHover={{ scale: 1.05 }}
              >
                <Product {...product} />
              </motion.div>
            );
          })}
        </motion.div>
      )}

      {!props?.hide && !isLastPage && (
        <motion.div
          className="load-more"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <LoadMore onLoadMoreEvt={handleLoadMore} />
        </motion.div>
      )}
    </motion.div>
  );
};

export default ProductResults;
